import { UserData } from '../_props'
import { titlesMap } from '../userFormData'
import { processCivility } from './_utils'
import useGetUserDataPointers from './useGetUserDataPointers'

const useGetSavableUserFormData = () => {
    const { getUserDataPointers } = useGetUserDataPointers()

    const getSavableUserFormData = async (user: UserData, editMode: boolean) => {
        const { professionPointer, speMentionPointer, qualificationPointer, specialityPointer } =
            await getUserDataPointers(user)

        const rppsNum = user.rpps && user.rpps.length === 11 ? Number.parseInt(user.rpps) : undefined
        const adeliNum = user.rpps && user.rpps.length === 9 ? Number.parseInt(user.rpps) : undefined

        const computedUser = {
            lastName: user.lastName,
            firstName: user.firstName,
            password: user.password,
            mail: user.email,
            sex: user.civility === 'MME' ? 'F' : 'M',
            title: user.title === titlesMap.none.value ? undefined : user.title,
            civility: processCivility(user.civility),
            privatePhone: user.privatePhone,
            contactPhone: user.contactPhone,
            notification: user.notification,
            healthSystemInfo: {
                objectId: user.extraHealthSystemInfoId,
                rppsNum,
                adeliNum: adeliNum ? String(adeliNum) : undefined,
                isEmployee: editMode ? user.isEmployee : false,
            },
            healthActivityInfo: {
                objectId: user.extraHealthActivityInfoId || null,
                profession: professionPointer ? [professionPointer] : null,
                speMention: user?.speMentions?.length ? speMentionPointer : null,
                qualification: qualificationPointer,
                speciality: specialityPointer,
                securedEmail: user.securedEmail,
            },
            technicalConfig: {
                objectId: user.technicalConfigObjectId || null,
                isComingFromRppsBase: user.validRpps,
                isTransEnabled: editMode ? user.isTransEnabled : true,
            },
            bankInfo: {
                objectId: user?.bankInfoObjectId || null,
            },
            address: {
                objectId: user?.addressObjectId || null,
            },
            extraUsageInfo: {
                objectId: user?.extraUsageInfoObjectId || null,
            },
            isEnabled: editMode ? user.activated : true,
            isReal: true,
            role: user.role,
            roleCode: user.role?.code,
            hcsDelegateUserId: user.hcsDelegateUserId,
            userHcsPosition: {
                objectId: user.userHcsPositionId || null,
                position: user.positionPointer || null,
            },
            realEmail: user.realEmail,
        }

        return computedUser
    }

    return {
        getSavableUserFormData,
    }
}

export default useGetSavableUserFormData
